import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import AvatarMaleImage from '../../assets/avatar-male.png';
import { UserDescription } from './UserDescription';

interface Props extends ChakraV3.AvatarProps {
  name: string;
  secondary?: string;
  picture?: string | null;
  showTooltip?: boolean;
}

export const UserAvatar = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { name, secondary, picture, showTooltip, ...rest } = props;

  const src = picture ?? AvatarMaleImage;
  const tooltipDisabled = showTooltip === false;
  const [isLoaded, setLoaded] = React.useState(false);

  return (
    <ChakraV3.Tooltip
      content={<UserDescription name={name} secondary={secondary} picture={picture} />}
      disabled={tooltipDisabled}
    >
      <ChakraV3.Box>
        <ChakraV3.Avatar
          ref={ref}
          src={src}
          icon={<ChakraV3.Image src={AvatarMaleImage} />}
          onLoad={() => setLoaded(true)}
          onError={() => setLoaded(true)}
          opacity={isLoaded ? 1 : 0}
          transition='opacity 0.2s ease-in-out'
          {...rest}
        />
      </ChakraV3.Box>
    </ChakraV3.Tooltip>
  );
});
